import { IArrowUpIconProps } from "interfaces";

const ArrowUpIcon = ({ className, onClick }: IArrowUpIconProps) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M7.99706 4.80544C8.46372 4.80544 8.93039 4.98544 9.28372 5.33878L13.6304 9.68544C13.8237 9.87878 13.8237 10.1988 13.6304 10.3921C13.4371 10.5854 13.1171 10.5854 12.9237 10.3921L8.57706 6.04544C8.25706 5.72544 7.73706 5.72544 7.41706 6.04544L3.07039 10.3921C2.87706 10.5854 2.55706 10.5854 2.36372 10.3921C2.17039 10.1988 2.17039 9.87878 2.36372 9.68544L6.71039 5.33878C7.06372 4.98544 7.53039 4.80544 7.99706 4.80544Z" />
        </svg>
    );
};

export default ArrowUpIcon;
